import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import featureFlag from './featureFlag';

interface FeatureFlagRouteProps {
  featureName: string;
}

const FeatureFlagRoute = ({ featureName }: FeatureFlagRouteProps) => {
  const hasFeature = featureFlag(featureName); // Dynamically check the feature flag

  if (hasFeature) {
    return <Outlet />; // Render nested routes if the feature flag is active
  } else {
    return <Navigate to="/feed" replace />; // Redirect if the feature is not available
  }
};

export default FeatureFlagRoute;
